var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "ethical_commission" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Этический комитет", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(_setup.EthicalCommissionContent, {
                    attrs: {
                      "ethical-commissions": _setup.context.ethical_commission,
                      "ethical-commission-meetings-count":
                        _setup.context.ethical_commission_meetings_count,
                      "ethical-commission-cases-count":
                        _setup.context.ethical_commission_cases_count,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1823717053
        ),
      })
    : _c(
        "div",
        [
          _c(_setup.EthicalCommissionContent, {
            attrs: {
              "ethical-commissions": _setup.context.ethical_commission,
              "ethical-commission-meetings-count":
                _setup.context.ethical_commission_meetings_count,
              "ethical-commission-cases-count":
                _setup.context.ethical_commission_cases_count,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }